/*********************
OWL CAROUSEL
*********************/
$(".carousel").owlCarousel({
  items: 1,
  lazyEffect: "fade",
  dots: false,
  URLhashListener: true,
  startPosition: 'URLHash',
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  mouseDrag: false,
  nav: true,
  loop: true,
  autoplay: true,
  autoplayTimeout: 10000,
  autoplayHoverPause: true,
  navText: '',
  autoHeight: true
});

/*********************
SCROLLING
*********************/
$(function () {
  $('a[href^="#"]:not(.menuTrigger)').on('click', function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });
});

/*********************
NAV MENU
*********************/
$(function () {
  $('.menuTrigger').on('click', function () {
    $(this).toggleClass('open');
    $('.menu-container').toggleClass('open');
  });
  $('.menu-container a').on('click', function () {
    $('.menuTrigger').toggleClass('open');
    $('.menu-container').toggleClass('open');
  });
});


/*********************
FAQ ACCORDION
*********************/
$(function () {
  $(".listBox dt").on("click", function () {
    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });
});

/*********************
FAQ TAB
*********************/
$(function () {
  $('.faqTab li').click(function () {
    //押されたのがリストの何番目か調べる
    var index = $('.faqTab li').index(this);
    //表示領域を全部非表示にする
    $('.listBoxWrap .listBox').hide();
    //押されたのと同じ番目のを表示する
    $('.listBoxWrap .listBox').eq(index).fadeIn();
    //.activeがついてるのを外す
    $('.faqTab li').removeClass('active');
    //押したやつにactiveを付与してる
    $(this).addClass('active');
  });
});

$(function () {
  //ハッシュタグ読み込み
  var hash = location.hash;
  if (hash.length) {
    //ハッシュがあったら
    if (hash.match(/#box/)) {
      //ハッシュタグが「#tab◯」ってなってたら
      //表示領域を全部非表示にする
      $('.listBoxWrap .listBox').hide();
      //メニューに付いてる「class="active"」を削除
      $('.faqTab li').removeClass('active');
      //「#tab◯」を「◯」だけにする
      var tabname = hash.slice(4.1);
      //「n番目を表示する」ってのをやりたいんだけど、
      //順番は0から始まるので「#tab1」は「0」、「#tab2」は「1」になる
      //なのでそのままだといっこ多くなっちゃうから1を引く
      tabname = tabname - 1;
      //n番目の内容を表示する
      $('.listBoxWrap .listBox').eq(tabname).fadeIn();
      //n番目のメニューに「class="active"」を付与する
      $('.faqTab li').eq(tabname).addClass('active');
    } else {
      //ハッシュタグが「#tab◯」じゃなかったら
      //1番目のメニューに「class="active"」を付与する
      $('.faqTab li').eq(0).addClass('active');
      //内容部分を全部非表示にする
      $('.listBoxWrap .listBox').hide();
      //1番目の内容を表示する
      $('.listBoxWrap .listBox').eq(0).fadeIn();
    }
  } else {
    //ハッシュがなかったら（普通にページ開いたときとか）
    //1番目のメニューに「class="active"」を付与する
    $('.faqTab li').eq(0).addClass('active');
    //内容部分を全部非表示にする
    $('.listBoxWrap .listBox').hide();
    //1番目の表示内容を表示する
    $('.listBoxWrap .listBox').eq(0).fadeIn();
  }
});